import { __EventDispatcher } from "../../_core/core";
import { EventClass, EventType } from "../config/Events";

//Import screens
import ScreenLoading from "../screens/Screen.Loading"; 
import ScreenGame from "../screens/Screen.Game"; 
import React, { useEffect, useState } from "react";

export enum screenState {
	LOADING = 'LOADING',
	GAME = 'GAME',
	ONBOARDING ='ONBOARDING'
}
 
export default function ScreenController() {
	const [state, setState ] = useState<screenState|string>("");
 
	const setScene = (_state: screenState): void => {
		if(state === _state) return;
 
		setState(_state);  
	}

	const onEventDispatched = (eventClass: EventClass, eventType: string, eventPayload: any): void => {  
		if (eventClass === EventClass.SYSTEM) {  
 			switch (eventType) {
				case EventType.SYSTEM.APP_CHAMGE_SCREEN:
					switch(eventPayload.screen){
						case screenState.LOADING: 
							setScene(screenState.LOADING);
							break;
						case screenState.GAME: 
							setScene(screenState.GAME);
							break;
					}
					break;
			}
		}
	}

	//Listen Dispatcher
	useEffect(() => { 
		__EventDispatcher.addListener(EventClass.SYSTEM, onEventDispatched, {}); 

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	//Display Screen
	if(state !== "") {
		switch(state) {
			case screenState.LOADING: return (<ScreenLoading />);  
			case screenState.GAME: return (<ScreenGame />);
			default: return (<></>);
		}
	} 
	return <></>
}